import { Tooltip } from '@/components/tooltip.js';
import { cn } from '@/lib/tailwind-utils.js';

interface TimeZoneTruncatedProps {
  timeZone: string;
  className?: string;
  /**
   * Max width applied to the truncated timezone text. Increase/decrease to match headers.
   */
  maxWidthClassName?: string;
}

export function TimeZoneTruncated({
  timeZone,
  className,
  maxWidthClassName = 'max-w-[150px]',
}: TimeZoneTruncatedProps) {
  return (
    <Tooltip
      trigger={
        <span
          className={cn(
            'inline-block align-middle truncate text-right leading-none relative bottom-[1px]',
            maxWidthClassName,
            className,
          )}
          style={{ direction: 'rtl' }}
        >
          {timeZone}
        </span>
      }
    >
      {timeZone}
    </Tooltip>
  );
}
